import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {PocService} from "../../../../services/poc-service/poc.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { LaboService } from '../../../../services/labo-service/labo.service';
import { FournisseurDTO } from '../../../_models/FournisseurDTO';
import { FournisseurService } from '../../../../services/fournisseur-service/fournisseur.service';

@Component({
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, PocService, ClientsService],
    imports: [
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
    ],

    selector: 'app-fournisseur',
    templateUrl: './fournisseur.component.html',
    styleUrl: './fournisseur.component.scss'
})
export class FournisseurComponent {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ShortClientDto[]
    dataSource = new MatTableDataSource<FournisseurDTO>();
    searchValue: string = ''
    fourn?: FournisseurDTO
    loadingTable: boolean = true;

displayedColumns: string[] = [
  'nom',          
  'contact',       
  'email',         
  'adresse',           
];
    columns: string[] = [...this.displayedColumns];

    constructor(
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private fournisseurService: FournisseurService,
        private laboService: LaboService,
        private clientService: ClientsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
    }

    ngOnInit(): void {
        this.fetchFournisseurList()
        this.initializeEditForm();
        this.fetchClientList();
        this.initializeCreateForm()
        this.getColsCookie()
    }

fetchFournisseurList(): void {
  this.fournisseurService.getAllFournisseurs().subscribe({
    next: (fournisseurs) => {
      console.log('✅ Fournisseurs actifs reçus:', fournisseurs);
      this.dataSource.data = fournisseurs;
    },
    error: (err) => {
      console.error("❌ Erreur :", err);
    }
  });
}

    

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            nom: ['', Validators.required],
            contact: ['', Validators.required],
            adresse: ['', Validators.required],
            email: ['', Validators.required],
        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            nom: ['', Validators.required],
            contact: ['', Validators.required],
            email: ['', Validators.required],
            adresse: ['', Validators.required],
        });
    }
    public phoneValidator(control: AbstractControl): ValidationErrors | null {
        const validPhonePattern = /^[+\d][\d\s-]*$/;
        return validPhonePattern.test(control.value) ? null : { invalidPhone: true };
    }

    getClientName(clientId: number): string {
        const client = this.clientList.find(client => client.id === clientId);
        return client?.socialReason ?? 'N/A';  // Utilisation de l'opérateur "??" pour éviter "undefined"
    }
      
      
    openEditModal(element: FournisseurDTO) {
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    private fetchClientList() {
        this.clientService.loadClients().subscribe({
            next: response => {
                if(response.status){
                    this.clientList = response.data
                }
            }
        })
    }
    saveFournisseur(): void {
        if (this.form.valid) {
            console.log('obj:',this.form.value);
            this.fournisseurService.createFournisseur(this.form.value).subscribe({
                next: response => {
                        this.form.reset();
                        this.fetchFournisseurList();
                        this.modalService.dismissAll();
                        this.dialogService.openSuccessDialog("Fournisseur ajouté avec succès.");
                },
                error: err => {
                    console.error("❌ Erreur API :", err);
                }
            });
        } else {
            this.dialogService.openInvalidFormDialog();
        }
    } 

    getSafeImageUrl(logo: string): string {
        if (logo && logo.startsWith('http')) {
          return logo; // Renvoie directement l'URL
        }
        if (logo && logo.startsWith('data:image')) {
          return logo; // Renvoie directement l'image en Base64
        }
        return 'https://www.exem.fr/wp-content/uploads/2023/10/Exem-Cofrac.png';  // Logo par défaut
      }
    updateForunisseur() {
        if (this.editForm.valid) {
            const formData = this.editForm.value;

            this.fournisseurService.updateFournisseur(formData.id,formData).subscribe({
                next: response => {
                        this.updateTableRow(response)
                        this.modalService.dismissAll()
                        this.dialogService.openSuccessDialog("Fournisseur modifié avec succès.")
                },
                error: err => this.handleErrorsService.catchError(err),
                complete: () => this.initializePaginatorAndSort()
            })
        } else {
            this.dialogService.openInvalidFormDialog()
        }
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer ce fournisseur?')
            .then((result: any) => {
                if (result) {
                    this.deleteFournisseur(element.id);
                }
            });
    }
    deleteFournisseur(id: number) {
        this.fournisseurService.deleteFournisseur(id).subscribe({
            next: response => {
                this.removeTableRow(id);
                this.dialogService.openSuccessDialog('Fournisseur supprimé avec succès')
            
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

    openViewModel(element: FournisseurDTO) {
        this.fourn = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});

    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`fournisseur_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const fournisseurCols = this.cookieService.get(`fournisseur_${this.user_name}`); // Get the cookie value

        if (fournisseurCols) {
            this.displayedColumns = JSON.parse(fournisseurCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', fournisseurCols);
        }
    }
}

